// extracted by mini-css-extract-plugin
export default {"summary":"purchase_summary__zaj0X","lineItem":"purchase_lineItem__9inY-"};